import React, { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Picture } from 'formlabs-web-components/Media';
import { Button, Link } from 'formlabs-web-components/Link';
import CenterModal from '../modal/CenterModal';
import blackIcon from '../../../../public/play_black.svg';
import whiteIcon from '../../../../public/play_white.svg';
import play from '../../../../public/play-icon.svg';
import playWhite from '../../../../public/play-white.svg';

import './YoutubeModal.module.css';
const YoutubeModal = DisplayComponent(
  class YoutubeModal extends PureComponent {
    state = {
      open: false
    };
    handleLinkClick = e => {
      e.preventDefault();
      this.setState({ open: true });
    };
    handleClose = () => {
      this.setState({ open: false });
    };
    render() {
      const {
        videoUrl,
        videoThumb,
        videoThumbAlt,
        linkDisplay,
        buttonText,
        buttonColor,
        fullBleedImage,
        playIcon,
        t
      } = this.props;
      return (
        <Fragment>
          {linkDisplay === 'text' && (
            <Link to={`#${videoUrl}`} onClick={this.handleLinkClick}>
              {buttonText}
            </Link>
          )}
          {linkDisplay === 'button' && (
            <Button
              to={`#${videoUrl}`}
              color={buttonColor}
              onClick={this.handleLinkClick}
            >
              <div styleName="button-fix">
                <Picture
                  largeImage={buttonColor === 'light' ? play : playWhite}
                  alt={t('youtube play icon')}
                />
                {buttonText}
              </div>
            </Button>
          )}
          {linkDisplay === 'image' && (
            <div styleName="image-container">
              <Link
                to={`#${videoUrl}`}
                onClick={this.handleLinkClick}
                aria-label={t('Open youtube video in a modal')}
              >
                {playIcon === 'black' && (
                  <div styleName="play-container">
                    <Picture
                      largeImage={blackIcon}
                      alt={t('youtube play icon')}
                    />
                  </div>
                )}
                {playIcon === 'white' && (
                  <div styleName="play-container">
                    <Picture
                      largeImage={whiteIcon}
                      alt={t('youtube play icon')}
                    />
                  </div>
                )}
                <Picture
                  largeImage={videoThumb}
                  fullBleed={fullBleedImage}
                  alt={videoThumbAlt}
                />
              </Link>
            </div>
          )}
          {this.state.open ? (
            <CenterModal
              id={videoUrl}
              onClose={this.handleClose}
              noPadding
              width="80vw"
            >
              <div styleName="responsive-video">
                <iframe
                  title="Youtube Modal"
                  src={videoUrl}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </CenterModal>
          ) : null}
        </Fragment>
      );
    }
  }
);

export default withTranslation()(YoutubeModal);
